// Place des Arts — flèches de navigation du carrousel, placées dans l'en-tête
// à côté du bouton « Voir plus » (réf Figma 1499:116771).
//
// Principe : on NE touche PAS au slideshow Horizon. Les flèches natives
// (<slideshow-arrows>, masquées en CSS) restent la source de vérité de l'état
// `disabled` géré par slideshow.js. Ce contrôleur :
//   1. délègue la navigation à l'API publique du slideshow (next()/previous()) ;
//   2. miroite l'état `disabled` des flèches natives sur les flèches d'en-tête ;
//   3. masque tout le groupe si le carrousel ne défile pas (les deux désactivées).
class PdaCarouselNav extends HTMLElement {
  connectedCallback() {
    this.prevBtn = this.querySelector('[data-pda-carousel-prev]');
    this.nextBtn = this.querySelector('[data-pda-carousel-next]');
    if (!this.prevBtn || !this.nextBtn) return;

    const scope = this.closest('.section-resource-list') || this.closest('.shopify-section') || document;
    this.slideshow = scope.querySelector('slideshow-component');
    if (!this.slideshow) {
      this.hidden = true;
      return;
    }

    // Flèches natives = source de vérité de l'état disabled (posé par slideshow.js).
    this.nativePrev = this.slideshow.querySelector('.slideshow-control--previous');
    this.nativeNext = this.slideshow.querySelector('.slideshow-control--next');

    this.prevBtn.addEventListener('click', () => this.go('previous'));
    this.nextBtn.addEventListener('click', () => this.go('next'));

    this.observer = new MutationObserver(() => this.sync());
    [this.nativePrev, this.nativeNext].forEach((btn) => {
      if (btn) this.observer.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    });

    this.onResize = () => this.sync();
    window.addEventListener('resize', this.onResize, { passive: true });

    this.sync();
    // slideshow.js fixe l'état initial après un frame (mesure de layout).
    requestAnimationFrame(() => this.sync());
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.onResize) window.removeEventListener('resize', this.onResize);
  }

  go(dir) {
    if (!this.slideshow) return;
    if (typeof this.slideshow[dir] === 'function') {
      this.slideshow[dir]();
    } else {
      const native = dir === 'next' ? this.nativeNext : this.nativePrev;
      if (native) native.click();
    }
  }

  sync() {
    const prevOff = this.nativePrev ? this.nativePrev.disabled : true;
    const nextOff = this.nativeNext ? this.nativeNext.disabled : true;
    this.prevBtn.disabled = prevOff;
    this.nextBtn.disabled = nextOff;
    // Carrousel non défilable → on masque le groupe entier.
    this.hidden = prevOff && nextOff;
  }
}

if (!customElements.get('pda-carousel-nav')) {
  customElements.define('pda-carousel-nav', PdaCarouselNav);
}
